export default {
	status_ready: 'Erledigt',
	status_seen: 'In Bearbeitung',
	status_unseen: 'Ungesichtet',
};
